import { connect } from 'react-redux';
import { initProductionSetup } from 'redux-core/productions/actions';

const mapDispatchToProps = {
  initProductionSetup,
};

export default connect(null, mapDispatchToProps);
